import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDiscoverData, getSearchByTerm } from '../api/discoverApiSlice';

const initialState = {
    currentStyle: localStorage.getItem('style') ? localStorage.getItem('style') : 34,
    currentSubStyle: null,
    currentCountry: 'FR',
    ranks: null,
    chart_styles: null,
    best_tracks: null,
    new_tracks: null,
    rankings: null,
    topArtists: null,
    topProducers: null,
    topLabels: null,
    topDates: null,
    topAlbums: null,
    searchTerm: null,
    topPlaylists: null,
    artistResults: null,
    trackResults: null,
    status: 'idle',
};

export const fetchDiscoverData = createAsyncThunk(
    'discover/getDiscoverData',
    async (style: number = 34) => {
        localStorage.setItem('style', `${style}`)
        var response = await getDiscoverData(style)
        return response
    }
);

export const sendSearchAsync = createAsyncThunk(
  'discover/sendSearchAsync',
  async (search: string) => {
      var response = await getSearchByTerm(search)
      return {res: response, searchTerm: search}
  }
);

export const discoverSlice = createSlice({
    name: 'discover',
    initialState,
    reducers: {
      setCurrentStyle: (state, action) => {
        state.currentStyle = action.payload
      },
      setCurrentSubStyle: (state, action) => {
        state.currentSubStyle = action.payload
      },
      setCurrentCountry: (state, action) => { 
        state.currentCountry = action.payload
        state.currentStyle = 34
      },
      setSearchTerm: (state, action) => {
        state.searchTerm = action.payload
        if (action.payload === null || action.payload === '')
        state.artistResults = null
        state.trackResults = null
      }
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchDiscoverData.pending, (state) => {
            state.status = 'loading';
            state.ranks = null
            state.rankings = null
            state.topArtists = null
            state.topDates = null
            state.topPlaylists = null
          })
          .addCase(fetchDiscoverData.fulfilled, (state, action) => {
            state.status = 'idle'
            state.ranks = action.payload.rankings
            state.chart_styles = action.payload.chart_styles
            state.rankings = action.payload.rankings
            state.topDates = action.payload.topDates
            state.topPlaylists = action.payload.topPlaylists
          })
          .addCase(sendSearchAsync.pending, (state) => {
            state.status = 'loading';
            // state.artistResults = null
            // state.trackResults = null
          })
          .addCase(sendSearchAsync.fulfilled, (state, action) => {
            state.status = 'idle'
            state.artistResults = action.payload.res.artists
            state.trackResults = action.payload.res.tracks
          });
      },
});

export const { setCurrentStyle, setSearchTerm, setCurrentCountry, setCurrentSubStyle } = discoverSlice.actions;

export const musicStyles = (state : any) => state.discover.chart_styles
export const bestTracks = (state : any) => state.discover.best_tracks
export const selectNewTracks = (state : any) => state.discover.new_tracks
export const ranks = (state : any) => state.discover.rankings
export const topTenArtists = (state : any) => state.discover.topArtists
export const topTenProducers = (state : any) => state.discover.topProducers
export const topLabels = (state : any) => state.discover.topLabels
export const topDates = (state : any) => state.discover.topDates
export const topAlbums = (state : any) => state.discover.topAlbums
export const topPlaylists = (state : any) => state.discover.topPlaylists
export const selectCurrentStyle = (state : any) => state.discover.currentStyle
export const selectCurrentSubStyle = (state : any) => state.discover.currentSubStyle
export const selectCurrentCountry = (state : any) => state.discover.currentCountry
export const selectArtistResults = (state : any) => state.discover.artistResults
export const selectTrackResults = (state : any) => state.discover.trackResults
export const selectSearchTerm = (state : any) => state.discover.searchTerm

export default discoverSlice.reducer;
